module.exports = __webpack_public_path__ + "img/iconography-1.31ab4851.jpg";